// Runtime app settings: fetched from this app's CDN once, cached in memory, kept off the MF runtime path.

let cache = null;

/** Cached app settings, or {} before loadAppSettings() resolves. */
export function getAppSettings() {
  return cache || {};
}

/** Test/host seam: set the cache directly; pass null to force a refetch. */
export function setAppSettings(value) {
  cache = value;
}

/** Fetch + cache appsettings.json once from this MFE's own origin; throws if it cannot be loaded, leaving the cache null so the next mount retries. */
export async function loadAppSettings() {
  if (cache) return cache;

  // appsettings.json sits one level above this module's chunk; not new URL('.', import.meta.url), which Vite rewrites to a data: URL in production builds.
  const moduleUrl = import.meta.url;
  const baseUrl = new URL(`${moduleUrl.slice(0, moduleUrl.lastIndexOf('/') + 1)}../`).href;

  let data;
  try {
    const response = await fetch(`${baseUrl}appsettings.json`, { cache: 'no-store' });
    if (!response.ok) throw new Error(`appsettings.json ${response.status}`);
    data = await response.json();
  } catch (error) {
    throw new Error(`[order-shipment-management-ui] failed to load appsettings.json: ${error.message}`, {
      cause: error,
    });
  }
  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    throw new Error('[order-shipment-management-ui] appsettings.json is not a JSON object');
  }
  cache = data;
  return cache;
}
